import React, { useEffect, useRef, useState } from "react";
import { FaArrowLeft, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import { axiosServer } from "../../../axiosServer";
import buildLink from "../../../urls";
import MessageAlert from "../../../components/messageAlert";
import Cookies from "js-cookie";
import { PlaySounds } from "../../../functions/playSounds";
import axios from "axios";
import ReactPaginate from "react-paginate";
import PointsLoader from "../../../components/PointsLoader";

const SellerStand = () => {
  const { playErrorSound, playSuccessSound } = PlaySounds();
  const [disabledInputs, setDisabledInputs] = useState(true);
  const [loadingAssign, setLoadingAssign] = useState(false);
  const productId = useRef(null);
  const newProductId = useRef(null);
  const binId = useRef(null);
  const quantity = useRef(null);
  const [sellerHistory, setSellerHistory] = useState(null);
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showMessgErr, setShowMessageErr] = useState(false);
  const [message, setMessage] = useState("");
  const [showMessgSucc, setShowMessageSucc] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [action, setAction] = useState();
  const [Action, setaction] = useState();
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [start, setStart] = useState(false);
  const [assign, setAssign] = useState(false);
  const [counterOnScan, setcounterOnScan] = useState();
  const [requestSuccess, setRequestSuccess] = useState(false);
  const [productInf, setProductInf] = useState(null);
  const [keyboardType, setKeyboardType] = useState("text");
  const [openAlert, setOpenAlert] = useState(false);
  const [ShowProductInput, setShowProductInput] = useState(false);
  const [ShowBinQuantityInput, setShowBinQuantityInput] = useState(false);
  const [quantityCounter, setQuantityCounter] = useState(0);
  const [isBinForm, setisBinForm] = useState(false);
  const [ShowChangedQuantityInput, setShowChangedQuantityInput] =
    useState(false);
  const [productIdInput, setProductIdInput] = useState("");
  // Pagination states
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(50); // Show 50 items per page
  const [totalPages, setTotalPages] = useState(0);
  // Countdown states
  const [isCountingDown, setIsCountingDown] = useState(false);
  const [currentQuantityValue, setCurrentQuantityValue] = useState("");
  const [originalQuantity, setOriginalQuantity] = useState("");
  const [binCounterDecreased, setBinCounterDecreased] = useState(false);
  const [originalProductId, setOriginalProductId] = useState("");
  const [currentQuantity, setCurrentQuantity] = useState(0);
  const [newProductIdDisabled, setNewProductIdDisabled] = useState(true);

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // Check if we should reset the counting state
  useEffect(() => {
    if (isCountingDown && quantity.current && quantity.current.value === "0") {
      setIsCountingDown(false);
    }
  }, [isCountingDown]);


  const sendAssignRequest = async (quantityToSend) => {
    const userID = getUserIdFromLocalStorage();
    const product = productId.current.value;

    try {
      const url = buildLink("seller_stand") + `&v2=true`;
      setLoadingAssign(true);
      await axiosServer
        .post(url, {
          user_id: userID,
          product_label: product, 
          quantity: quantityToSend || originalQuantity, 
          bin_id: binId.current.value,
          action: "assign",
        })
        .then((response) => {
          setLoadingAssign(false);
          if (response.data.success) {
            playSuccessSound();
            setMessage("Product successfully assigned to seller");
            setShowMessageSucc(true);
            setTimeout(() => {
              setShowMessageSucc(false);
            }, 3000);
            
            // Reset the form after successful submission
            productId.current.value = "";
            binId.current.value = "";
            quantity.current.value = "";
            setCurrentQuantityValue("");
            setOriginalQuantity("");
            setIsCountingDown(false);
            productId.current.focus();
          } else {
            playErrorSound();
            setMessage(response.data.message || "Failed to assign product");
            setShowMessageErr(true);
            setTimeout(() => {
              setShowMessageErr(false);
            }, 3000);
          }
        });
    } catch (e) {
      setLoadingAssign(false);
      playErrorSound();
      setMessage(e.response?.data?.message || "An error occurred");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };




  const getSellerHistory = async (e, page = 0, productIdValue = null) => {
    setSellerHistory(null);
    if (e) {
      e.preventDefault();
    }
    setLoading(true);
    
    if (productId.current.value === "") {
      setMessage("Please enter a product ID or SKU.");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      playErrorSound();
      setLoading(false);
      return;
    }
    
    const productValue = productIdValue || productId.current.value;
    
    try {
      if (productId.current) {
        productId.current.blur();
      }

      const url = buildLink("getSellerStandHistory") + 
        `${productValue}` +
        `&page=${page + 1}` +
        `&user_id=${getUserIdFromLocalStorage()}` +
        `&limit=${itemsPerPage}`;
        
      const response = await axiosServer.get(url);
      if (response.data.success) {
        setSellerHistory(response.data.data);
        setTotalPages(response.data.total_pages || 0);
        setLoading(false);
        setMessage("Seller history fetched successfully");
        setShowMessageSucc(true);
        playSuccessSound();
        setTimeout(() => {
          setShowMessageSucc(false);
        }, 3000);
      } else {
        setLoading(false);
        playErrorSound();
        setMessage(response.data.message || "Failed to fetch seller history");
        setShowMessageErr(true);
        setTimeout(() => {
          setShowMessageErr(false);
        }, 3000);
      }
    } catch (error) {
      setLoading(false);
      playErrorSound();
      setMessage("An error occurred while fetching seller history");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  }




  useEffect(() => {
    if (quantityCounter === 0) {
      if (productId.current) {
        productId.current.value = "";
        productId.current.disabled = false;
      }
      if (binId.current) {
        binId.current.value = "";
      }
   
      setisBinForm(false);
      setProductIdInput("");
      setShowProductInput(false);
      setShowBinQuantityInput(false);
      setShowChangedQuantityInput(false);
    }
  }, [quantityCounter]);

  useEffect(() => {
    setDisabledInputs(true);
  }, [activeTab]);

  const getUserIdFromLocalStorage = () => {
    return localStorage.getItem("userID");
  };

  async function assignProductToSeller(e) {
    e.preventDefault();
    
    const product = productId.current.value;
    const currentQuantity = parseInt(quantity.current.value, 10);

    if (!product) {
      playErrorSound();
      setMessage("Please enter a product ID or SKU");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }

    if (!binId.current.value) {
      playErrorSound();
      setMessage("Please enter a bin ID");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }

    if (!quantity.current.value) {
      playErrorSound();
      setMessage("Please enter a quantity");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }

    if (isNaN(currentQuantity) || currentQuantity <= 0) {
      playErrorSound();
      setMessage("Please enter a valid quantity");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }

    // Store the original quantity ONLY at the very beginning, never overwrite it
    if (!isCountingDown && !originalQuantity) {
      setOriginalQuantity(currentQuantity.toString());
    }

    // Special handling for quantity of 1 - send request immediately
    if (currentQuantity === 1) {
      quantity.current.value = "0";
      setCurrentQuantityValue("0");
      setIsCountingDown(false);
      sendAssignRequest(originalQuantity || currentQuantity.toString()); // Use originalQuantity or fallback
      return;
    }

    // Decrease the quantity in the input field
    const newQuantity = currentQuantity - 1;
    quantity.current.value = newQuantity.toString();
    setCurrentQuantityValue(newQuantity.toString());
    
    // If quantity reaches 0, send the request
    if (newQuantity === 0) {
      setIsCountingDown(false);
      sendAssignRequest(originalQuantity); // Pass the original quantity that was set at the beginning
      return;
    }

    setIsCountingDown(true);
  }
  // Function to send the actual unassign API request
  const sendUnassignRequest = async (quantityToSend) => {
    const userID = getUserIdFromLocalStorage();
    const product = productId.current.value;

    const requestData = {
      user_id: userID,
      product_label: product, 
      quantity: quantityToSend || originalQuantity, 
      bin_id: binId.current.value,
      action: "unassign", 
    };

    try {
      const url = buildLink("seller_stand") + `&v2=true`;
      setLoadingAssign(true);
      await axiosServer
        .post(url, requestData)
        .then((response) => {
          setLoadingAssign(false);
          if (response.data.success) {
            playSuccessSound();
            setMessage("Product successfully unassigned from seller");
            setShowMessageSucc(true);
            setTimeout(() => {
              setShowMessageSucc(false);
            }, 3000);
            
            // Reset the form after successful submission
            productId.current.value = "";
            binId.current.value = "";
            quantity.current.value = "";
            setCurrentQuantityValue("");
            setOriginalQuantity("");
            setIsCountingDown(false);
            productId.current.focus();
          } else {
            playErrorSound();
            setMessage(response.data.message || "Failed to unassign product");
            setShowMessageErr(true);
            setTimeout(() => {
              setShowMessageErr(false);
            }, 3000);
          }
        });
    } catch (e) {
      setLoadingAssign(false);
      playErrorSound();
      setMessage(e.response?.data?.message || "An error occurred");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
    }
  };

  async function unAssignProductToSeller(e) {
    e.preventDefault();
    
    const product = productId.current.value;
    const currentQuantity = parseInt(quantity.current.value, 10);

    if (!product) {
      playErrorSound();
      setMessage("Please enter a product ID or SKU");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }

    if (!binId.current.value) {
      playErrorSound();
      setMessage("Please enter a bin ID");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }

    if (!quantity.current.value) {
      playErrorSound();
      setMessage("Please enter a quantity");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }

    if (isNaN(currentQuantity) || currentQuantity <= 0) {
      playErrorSound();
      setMessage("Please enter a valid quantity");
      setShowMessageErr(true);
      setTimeout(() => {
        setShowMessageErr(false);
      }, 3000);
      return;
    }

    // Store the original quantity ONLY at the very beginning, never overwrite it
    if (!isCountingDown && !originalQuantity) {
      setOriginalQuantity(currentQuantity.toString());
    }

    // Special handling for quantity of 1 - send request immediately
    if (currentQuantity === 1) {
      quantity.current.value = "0";
      setCurrentQuantityValue("0");
      setIsCountingDown(false);
      sendUnassignRequest(originalQuantity || currentQuantity.toString()); // Use originalQuantity or fallback
      return;
    }

    // Decrease the quantity in the input field
    const newQuantity = currentQuantity - 1;
    quantity.current.value = newQuantity.toString();
    setCurrentQuantityValue(newQuantity.toString());
    
    // If quantity reaches 0, send the request
    if (newQuantity === 0) {
      setIsCountingDown(false);
      sendUnassignRequest(originalQuantity); // Pass the original quantity that was set at the beginning
      return;
    }

    setIsCountingDown(true);
  }


  const history = useNavigate();

  useEffect(() => {
    productId.current.focus();
  }, []);

  useEffect(() => {
    Cookies.set("productInfo", JSON.stringify(info), { expires: 7 });
    Cookies.set("action", action, { expires: 7 });
  }, [info, action]);

  const handleTrashClick = () => {
    binId.current.value = "";
    binId.current.focus();
  };
  const handleTrashQuantityClick = () => {
    quantity.current.value = "";
    quantity.current.focus();
  };


  const handleProductIdTrashClick = () => {
    productId.current.value = "";
    productId.current.focus();
  };

  useEffect(() => {
    setSellerHistory(null);
    setInfo(null);
    setLoading(false);
    setShowMessageErr(false);
    setMessage("");
    setShowMessageSucc(false);
    setAction(null);
    setaction(null);
    setLoadingSearch(false);
    setStart(false);
    setAssign(false);
    setProductInf(null);
    setcounterOnScan(undefined);
    setRequestSuccess(false);
    setKeyboardType("text");
    setIsCountingDown(false);
    setCurrentQuantityValue("");
    setOriginalQuantity("");
  }, [activeTab]);

  // Pagination logic - now using server-side pagination
  const pageCount = totalPages;

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    // Trigger a new API call with the new page
    const item = productId.current.value;
    if (item) {
      getSellerHistory(null, event.selected, item);
    }
  };

  const onSubmitSellerHistory = (event) => {
    setCurrentPage(0); // Reset to first page when searching
    getSellerHistory(event);
  };

  // Handle bin ID keyup - decrease counter only once on first visit when Enter is pressed
  const handleBinIdKeyUp = (e) => {
    // Only trigger when Enter key is pressed
    if (e.key === 'Enter' && !binCounterDecreased) {
      // Store original product ID and decrease quantity on first bin entry
      if (productId.current && quantity.current) {
        setOriginalProductId(productId.current.value);
        const originalQty = parseInt(quantity.current.value) || 0;
        
        // Store the original quantity for API call later
        setOriginalQuantity(originalQty.toString());
        
        const newQty = originalQty - 1;
        
        // Update quantity in input field and state
        quantity.current.value = newQty.toString();
        setCurrentQuantityValue(newQty.toString());
        setCurrentQuantity(newQty);
        
        // Handle different workflows based on active tab
        if (activeTab === 1) {
          // Assign tab - enable new product ID input for continued workflow
          setNewProductIdDisabled(false);
          // If quantity reaches 0, send assign request immediately
          if (newQty === 0) {
            sendAssignRequest(originalQty.toString());
            
            // Reset the form after API call
            setTimeout(() => {
              // Reset all input fields
              if (productId.current) productId.current.value = "";
              if (quantity.current) quantity.current.value = "";
              if (binId.current) binId.current.value = "";
              if (newProductId.current) newProductId.current.value = "";
              
              // Reset all state variables
              setCurrentQuantityValue("");
              setOriginalQuantity("");
              setOriginalProductId("");
              setCurrentQuantity(0);
              setBinCounterDecreased(false);
              setNewProductIdDisabled(true);
              
              // Focus back to the first input
              if (productId.current) productId.current.focus();
            }, 100);
          }
        } else if (activeTab === 2) {
          // Unassign tab - enable new product ID input for continued workflow
          setNewProductIdDisabled(false);
          // If quantity reaches 0, send unassign request immediately
          if (newQty === 0) {
            sendUnassignRequest(originalQty.toString());
            
            // Reset the form after API call
            setTimeout(() => {
              // Reset all input fields
              if (productId.current) productId.current.value = "";
              if (quantity.current) quantity.current.value = "";
              if (binId.current) binId.current.value = "";
              
              // Reset all state variables
              setCurrentQuantityValue("");
              setOriginalQuantity("");
              setOriginalProductId("");
              setCurrentQuantity(0);
              setBinCounterDecreased(false);
              
              // Focus back to the first input
              if (productId.current) productId.current.focus();
            }, 100);
          }
        }
      }
      setBinCounterDecreased(true);
    }
  };

  // Handle new product ID comparison and quantity decrement on Enter key press
  const handleNewProductIdKeyUp = (e) => {
    // Only trigger when Enter key is pressed
    if (e.key === 'Enter') {
      const newId = e.target.value;
      
      if (newId && originalProductId) {
        if (newId === originalProductId) {
          // If new product ID matches original, decrement quantity
          if (currentQuantity > 0) {
            const newQuantity = currentQuantity - 1;
            setCurrentQuantity(newQuantity);
            
            // Update the quantity input field
            if (quantity.current) {
              quantity.current.value = newQuantity.toString();
              setCurrentQuantityValue(newQuantity.toString());
            }
            
            // If quantity reaches 0, send API request based on active tab
            if (newQuantity === 0) {
              // Check which tab is active and call appropriate API function
              if (activeTab === 1) {
                // Assign tab - use assign request
                sendAssignRequest(originalQuantity);
              } else if (activeTab === 2) {
                // Unassign tab - use unassign request
                sendUnassignRequest(originalQuantity);
              }
              
              // Reset the form after API call
              setTimeout(() => {
                // Reset all input fields
                if (productId.current) productId.current.value = "";
                if (quantity.current) quantity.current.value = "";
                if (binId.current) binId.current.value = "";
                if (newProductId.current) newProductId.current.value = "";
                
                // Reset all state variables
                setCurrentQuantityValue("");
                setOriginalQuantity("");
                setOriginalProductId("");
                setCurrentQuantity(0);
                setBinCounterDecreased(false);
                setNewProductIdDisabled(true);
                
                // Focus back to the first input
                if (productId.current) productId.current.focus();
              }, 100); // Small delay to ensure API call is initiated
            }
          }
        } else {
          // Product IDs don't match - show alert and clear the input
          playErrorSound();
          setMessage(`Product ID does not match. Expected: ${originalProductId}`);
          setShowMessageErr(true);
          setTimeout(() => {
            setShowMessageErr(false);
          }, 3000);
          
          // Clear the new product ID input
          if (newProductId.current) {
            newProductId.current.value = "";
          }
        }
      }
    }
  };

  return (
    <>
      <div className=" h-full bg-white">
        {/* header */}
        <div className=" mb-5 sticky top-0  z-50 flex flex-col bg-white">
          <div className=" w-full bg-dbase h-16">
            <div className=" container flex relative gap-7 flex-row justify-start w-full text-white  h-full my-auto">
              <button onClick={() => history(-1)}>
                <FaArrowLeft />
              </button>
              <h2 className=" text-xl my-auto">Seller Stand</h2>
            </div>
          </div>
        </div>

        <div className=" w-screen  bg-white my-4 container overflow-x-auto">
          <div className=" flex w-full justify-start gap-3">
            <button
              onClick={() => setActiveTab(1)}
              className={`${
                activeTab === 1 ? "bg-dbase text-white" : "bg-white text-dblack"
              }  transition-all w-full py-2  rounded-full text-nowrap px-3`}
            >
              {" "}
              Assign to Seller
            </button>
            <button
              onClick={() => setActiveTab(2)}
              className={`${
                activeTab === 2 ? "bg-dbase text-white" : "bg-white text-dblack"
              }  transition-all w-full py-2 rounded-full text-nowrap px-3`}
            >
              {" "}
              UnAssign from Seller
            </button>

             <button
              onClick={() => setActiveTab(3)}
              className={`${
                activeTab === 3 ? "bg-dbase text-white" : "bg-white text-dblack"
              }  transition-all w-full py-2 rounded-full text-nowrap px-3`}
            >
              {" "}
            Seller History
            </button>

          </div>
        </div>

      

        {activeTab === 1 && (
          <>
            <div className="container">
              <form
                className="flex flex-col justify-center gap-3"
                onSubmit={(e) => assignProductToSeller(e)}
              >
                <div className="flex flex-row items-center gap-3">
                  <div className="relative flex-1">
                    <input
                      required
                      ref={productId}
                      type="text"
                      className="border border-dlabelColor disabled:bg-dplaceHolder outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                      placeholder="Product ID or SKU"
                    />
                    <div onClick={() => handleProductIdTrashClick()}>
                      <FaTrash className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20" />
                    </div>
                  </div>
                </div>

                <div className=" flex flex-row justify-center gap-3  mt-5">
                  <div className="relative flex-1">
                    <input
                      required
                      ref={quantity}
                      type="number"
                      min="1"
                      className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                      placeholder="Quantity"
                      onChange={(e) => setCurrentQuantityValue(e.target.value)}
                      onInput={(e) => {
                        // Prevent negative numbers and zero
                        if (e.target.value < 1) {
                          e.target.value = '';
                          setCurrentQuantityValue('');
                        }
                      }}
                    />
                    <div>
                      <FaTrash
                        onClick={() => {
                          handleTrashQuantityClick();
                          setCurrentQuantityValue("");
                        }}
                        className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
                      />
                    </div>
                  </div>
                </div>

                <div className=" flex flex-row justify-center gap-3  mt-5">
                  <div className="relative flex-1">
                    <input
                      required
                      ref={binId}
                      type="text"
                      className="border border-dlabelColor outline-dbase w-full rounded-md  py-3 pr-8  pl-2"
                      placeholder="Bin ID"
                      onKeyUp={handleBinIdKeyUp}
                    />
                    <div>
                      <FaTrash
                        onClick={() => handleTrashClick()}
                        className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20 "
                      />
                    </div>
                  </div>
                </div>
              </form>
              <div className="flex flex-row items-center gap-3 mt-8">
                  <div className="relative flex-1">
                    <input
                      required
                      ref={newProductId}
                      type="text"
                      className="border border-dlabelColor disabled:bg-dplaceHolder outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                      placeholder="New Product ID or SKU"
                      disabled={newProductIdDisabled}
                      onKeyUp={handleNewProductIdKeyUp}
                    />
                    <div onClick={() => handleProductIdTrashClick()}>
                      <FaTrash className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20" />
                    </div>
                  </div>
                </div>

              {productInf && (
                <div className="h-full flex flex-col justify-center text-center gap-3">
                  <div className="flex gap-2 justify-center  flex-row my-4">
                    <div className="h-full my-auto  lg:ml-80 w-full items-center">
                      <img className=" w-80 h-80" src={productInf.image} />
                    </div>
                    <div>
                      <div>
                        <h2 className="text-start font-bold">Product :</h2>
                        <table className="w-full ">
                          <tbody>
                            <tr>
                              <td
                                colSpan={2}
                                className="border text-center border-dlabelColor px-2 py-2 whitespace-pre-wrap"
                              >
                                Sku: {productInf.sku}
                              </td>
                            </tr>
                            <tr>
                              <td
                                colSpan={2}
                                className="border text-center border-dlabelColor px-2 py-2 whitespace-pre-wrap"
                              >
                                Quantity: {productInf.quantity}
                              </td>
                            </tr>
                            <tr>
                              {!productInf.option_name && (
                                <td
                                  colSpan={2}
                                  className="border text-center border-dlabelColor px-2 py-2"
                                >
                                  Big Upc: {productInf.big_upc || "_"}
                                </td>
                              )}
                            </tr>
                            {productInf.address && (
                              <tr>
                                <td
                                  colSpan={2}
                                  className="border flex flex-col justify-center text-center border-dlabelColor px-2 py-2"
                                >
                                  <strong>Address:</strong>{" "}
                                  <span>{productInf.address}</span>
                                </td>
                              </tr>
                            )}
                            {productInf.upc && !productInf.bin && (
                              <div className="flex flex-col">
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Upc: {productInf.upc}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Min Upc: {productInf.min_upc_quantity || "_"}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Max Upc: {productInf.max_upc_quantity || "_"}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Upc Qty: {productInf.upc_quantity || "_"}
                                </td>
                              </div>
                            )}
                            {!productInf.upc && productInf.bin && (
                              <>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Bin: {productInf.bin}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Min Bin: {productInf.min_bin_quantity || "_"}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Max Bin: {productInf.max_bin_quantity || "_"}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Bin Qty: {productInf.bin_quantity || "_"}
                                </td>
                                <td className="border text-center border-dlabelColor px-2 py-2">
                                  Address: {productInf.address || "_"}
                                </td>
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <div className="w-full rounded-lg border   bg-dplaceHolder py-3">
                    In Stand Qty : {productInf.in_stand_quantity}
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        {activeTab === 2 && (
          <>
            <div className="container">
              <form
                className="flex flex-col justify-center gap-3"
                onSubmit={(e) => unAssignProductToSeller(e)}
              >
                <div className="flex flex-row items-center gap-3">
                  <div className="relative flex-1">
                    <input
                      ref={productId}
                      type="text"
                      className="border border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                      placeholder="Product ID or SKU"
                      required
                      
                    />
                    <div onClick={() => (productId.current.value = "")}>
                      <FaTrash className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20" />
                    </div>
                  </div>
                </div>

                <div className="flex flex-row justify-center gap-3 mt-5">
                  <div className="relative flex-1">
                    <input
                      required
                      ref={quantity}
                      type="number"
                      min="1"
                      className="border border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                      placeholder="Quantity"
                      onChange={(e) => setCurrentQuantityValue(e.target.value)}
                      onInput={(e) => {
                        // Prevent negative numbers and zero
                        if (e.target.value < 1) {
                          e.target.value = '';
                          setCurrentQuantityValue('');
                        }
                      }}
                    />
                    <div>
                      <FaTrash
                        onClick={() => {
                          handleTrashQuantityClick();
                          setCurrentQuantityValue("");
                        }}
                        className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20"
                      />
                    </div>
                  </div>
                </div>

                <div className="flex flex-row justify-center gap-3 mt-5">
                  <div className="relative flex-1">
                    <input
                      ref={binId}
                      type="text"
                      className="border border-dlabelColor outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                      placeholder="Bin ID"
                      required
                      onKeyUp={handleBinIdKeyUp}
                    />
                    <div>
                      <FaTrash
                        onClick={() => handleTrashClick()}
                        className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20"
                      />
                    </div>
                  </div>
                </div>
              </form>
              <div className="flex flex-row items-center gap-3 mt-8">
                  <div className="relative flex-1">
                    <input
                      required
                      ref={newProductId}
                      type="text"
                      className="border border-dlabelColor disabled:bg-dplaceHolder outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                      placeholder="New Product ID or SKU"
                      disabled={newProductIdDisabled}
                      onKeyUp={handleNewProductIdKeyUp}
                    />
                    <div onClick={() => handleProductIdTrashClick()}>
                      <FaTrash className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20" />
                    </div>
                  </div>
                </div>
            </div>
          </>
        )}

          {activeTab === 3 && (
          <div className="container">
             <form
                className="flex flex-col justify-center gap-3"
                onSubmit={(e) => onSubmitSellerHistory(e)}
              >
              
                <div className="flex flex-row items-center gap-3">
                  <div className="relative flex-1">
                    <input
                      required
                      ref={productId}
                      type="text"
                      className="border border-dlabelColor disabled:bg-dplaceHolder outline-dbase w-full rounded-md py-3 pr-8 pl-2"
                      placeholder="Product ID or SKU"
                    />
                    <div onClick={() => handleProductIdTrashClick()}>
                      <FaTrash className="absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer opacity-20" />
                    </div>
                  </div>
                </div>
              </form>

              {loading && (
                <div className="flex justify-center mt-6">
                  <PointsLoader />
                </div>
              )}

              {sellerHistory && sellerHistory.length > 0 && !loading && (
                <div className="px-3 mt-6">
                  <div className="bg-white border border-gray-400">
                    {/* Table View - Responsive */}
                    <div className="overflow-x-auto">
                      <table className="w-full border-collapse min-w-[600px]">
                        <thead className="bg-gray-50">
                          <tr className="border-b border-gray-400">
                            <th className="px-4 py-3 text-center text-md font-bold text-gray-500 tracking-wider border-r border-gray-400">
                              Username
                            </th>
                            <th className="px-4 py-3 text-center text-md font-bold text-gray-500 tracking-wider border-r border-gray-400">
                              Bin ID
                            </th>
                            <th className="px-4 py-3 text-center text-md font-bold text-gray-500 tracking-wider border-r border-gray-400">
                              Quantity
                            </th>
                            <th className="px-4 py-3 text-center text-md font-bold text-gray-500 tracking-wider">
                              Date Added
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-400">
                          {sellerHistory.map((product, index) => (
                            <tr
                              key={index}
                              className={`hover:bg-gray-50 transition-colors ${
                                index % 2 === 0 ? "bg-white" : "bg-gray-50"
                              }`}
                            >
                              <td className="px-4 py-4 whitespace-nowrap text-md text-gray-900 border-r border-gray-400 text-center">
                                <div className="flex items-center justify-center">
                                  {product.username}
                                </div>
                              </td>
                              <td className="px-4 py-4 whitespace-nowrap text-md font-mono text-gray-900 border-r border-gray-400 text-center">
                                {product.bin_id}
                              </td>
                              <td className="px-4 py-4 whitespace-nowrap text-md text-gray-900 border-r border-gray-400 text-center">
                                <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-md">
                                  {product.quantity_display}
                                </span>
                              </td>
                              <td className="px-4 py-4 whitespace-nowrap text-md text-gray-500 text-center">
                                <div className="text-md text-center">
                                  {product.date_added
                                    ? new Date(product.date_added).toLocaleDateString()
                                    : "N/A"}
                                  <br />
                                  <span className="text-gray-400 text-md">
                                    {product.date_added
                                      ? new Date(product.date_added).toLocaleTimeString()
                                      : ""}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                  {/* Pagination */}
                  {pageCount > 1 && (
                    <div className="px-4 py-3">
                      <ReactPaginate
                        previousLabel="← Previous"
                        nextLabel="Next →"
                        pageCount={pageCount}
                        onPageChange={handlePageClick}
                        containerClassName="flex items-center justify-center space-x-2"
                        pageClassName="inline-block"
                        pageLinkClassName="px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
                        previousClassName="inline-block"
                        previousLinkClassName="px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
                        nextClassName="inline-block"
                        nextLinkClassName="px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
                        activeClassName="bg-dbase text-white rounded-md"
                        activeLinkClassName="px-3 py-2 text-sm text-white bg-dbase rounded-md"
                        disabledClassName="opacity-50 cursor-not-allowed"
                        breakLabel="..."
                        breakClassName="inline-block"
                        breakLinkClassName="px-3 py-2 text-sm text-gray-500"
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        forcePage={currentPage}
                      />
                    </div>
                  )}
                  
                  {/* Add space below table and pagination */}
                  <div className="pb-8"></div>
                </div>
              )}
            </div>
          )}

        {openAlert && (
          <div
            onClick={() => setOpenAlert(false)}
            className=" fixed w-full h-full inset-0  bg-dblackk  bg-opacity-35 z-40 "
          ></div>
        )}
        {openAlert && (
          <div className=" fixed w-[70%] rounded-md  top-[40%] px-4 py-3 z-50 left-[13%] bg-white">
            <div className=" relative w-full h-full flex flex-col  justify-center">
              <h2 className=" text-xl text-dblackk font-bold">
                Note!. This item is in another address please{" "}
                <span className=" text-dbase">unassign </span> before assigning
                again!
              </h2>
              <div className=" w-full flex flex-row mt-5 justify-center gap-5">
                <button
                  onClick={() => {
                    setOpenAlert(false);
                  }}
                  className=" w-full py-2 bg-dbase1  text-white text-lg font-bold rounded-md"
                >
                  {" "}
                  Ok{" "}
                </button>
              </div>
            </div>
          </div>
        )}

        <MessageAlert
          message={message}
          type={showMessgErr ? "err" : "succ"}
          showMessg={showMessgErr || (showMessgSucc && true)}
        />
      </div>
    </>
  );
};

export default SellerStand;
